import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { public: true },
    component: Login
  },
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: () => import('@/views/home/Index.vue'),
    children: [
      { path: '/home', meta: { public: true }, component: () => import('@/views/home/Home.vue') },
      { path: '/service', component: () => import('@/views/home/Service.vue') },
      { path: '/bill', component: () => import('@/views/home/Bill.vue') },
      { path: '/my', component: () => import('@/views/home/My.vue') }
    ]
  },
  {
    path: '/billdetail',
    name: 'BillDetail',
    component: () => import('@/views/BillDetail.vue')
  },
  {
    path: '/repay',
    name: 'Repay',
    component: () => import('@/views/Repay.vue')
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: () => import('@/views/Contracts.vue')
  },
  {
    path: '/contract-detail/:id',
    name: 'ContractDetail',
    component: () => import('@/views/ContractDetail.vue')
  },
  {
    path: '/settle-certs',
    name: 'SettleCertList',
    component: () => import('@/views/SettleCertList.vue')
  },
  {
    path: '/settle-cert/:id',
    name: 'SettleCert',
    component: () => import('@/views/SettleCert.vue')
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: () => import('@/views/Coupon.vue')
  },
  {
    path: '/set',
    name: 'Set',
    component: () => import('@/views/Set.vue')
  },
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  if (to.meta.public || to.matched.some((r) => r.meta.public)) return next()
  if (localStorage.getItem('token')) return next()
  Toast({ message: '请先登录！', duration: 1000 })
  next({ path: '/login' })
})

export default router
